import * as API from "@/services/API";

export default {
    getRegister() {
        return API.apiClient.get('/data/register');
    },
}
